import { CurrencyType } from '@fi-app/customer-billing/customer-billing-price/currency-type';
import { fiPaymentMethodType } from '@fi-app/customer-billing/payment-method-type';
import { fiInvoiceMethodType } from '@fi-app/customer-billing/customer-billing-invoice/invoice-method-type';
import { AddressModel } from '@fi-app/utilities/address/address.model';
import { BillingContactModel } from '../billing-contact.model';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { IFiCustomerData } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiAppSettings } from '@fi-shared/fi-app-settings';
import { IContactModel } from '@fi-shared/models/common';

export class BusinessUnitInvoiceInformationModel {
    Id = 0;
    InvoiceLanguageType = FiApplicationLanguageType.Swedish;
    PaymentCurrencyType = CurrencyType.SEK;
    InvoiceMethodType = fiInvoiceMethodType.Email;
    PaymentType = fiPaymentMethodType.Invoice;
    ReceiverName = '';
    ReceiverEmail = '';
    Contacts: BillingContactModel[];
    ReceiverAddress: AddressModel;
    Address: AddressModel;
    CurrencyType;
    LanguageType;

    constructor(data, customerData: IFiCustomerData) {
        this.intPropertiesWithObjects(this);

        if (data) this.Initialize(data, customerData);
    }

    Initialize(data, customerData: IFiCustomerData) {
        Object.assign(this, data);

        this.InvoiceLanguageType = data.InvoiceLanguageType || customerData.DefaultApplicationLanguageType;
        this.PaymentCurrencyType = data.PaymentCurrencyType || FiAppSettings.DefaultPaymentCurrency;
        this.InvoiceMethodType = data.InvoiceMethodType || fiInvoiceMethodType.Email;
        this.PaymentType = data.PaymentType || fiPaymentMethodType.Invoice;

        this.intPropertiesWithObjects(this);

        this.ReceiverAddress.Initialize(data.ReceiverAddress);

        if (data.Contacts && data.Contacts.length > 0) {
            this.Contacts = [];
            data.Contacts.forEach((contact) => {
                const contactModel = new BillingContactModel();
                contactModel.Initialize(contact);
                this.Contacts.push(contactModel);
            });
        }
    }

    private intPropertiesWithObjects(data) {
        data.ReceiverAddress = new AddressModel();
        data.Contacts = [new BillingContactModel()];
        data.Contacts[0].IsDefault = true;
    }
}
